import { IVideoClip, Size } from 'types';
import measurement from 'utils/measurement';

export function getPlacementFromVideoClip(
  videoClip: IVideoClip,
  canvas: Size<number>,
) {
  const { position, style } = videoClip;

  return {
    left: measurement(position.left).toUnit('vw', canvas),
    top: measurement(position.top).toUnit('vh', canvas),
    height: measurement(style.height).toUnit('vh', canvas),
    width: measurement(style.width).toUnit('vw', canvas),
  };
}
